(() => {
  if (window.__pleesdInpostInit) return;
  window.__pleesdInpostInit = true;

  const widgetURL = 'https://geowidget.inpost.pl/inpost-geowidget.js';
  const cssURL = 'https://geowidget.inpost.pl/inpost-geowidget.css';
  let widgetLoadPromise;

  const ensureWidget = () => {
    if (customElements.get('inpost-geowidget')) return Promise.resolve();
    if (!widgetLoadPromise) {
      widgetLoadPromise = new Promise((resolve, reject) => {
        if (!document.querySelector(`link[href="${cssURL}"]`)) {
          const stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href = cssURL;
          document.head.appendChild(stylesheet);
        }
        const script = document.createElement('script');
        script.src = widgetURL;
        script.async = true;
        script.onload = () => customElements.whenDefined('inpost-geowidget').then(resolve, reject);
        script.onerror = () => reject(new Error('Nie udało się pobrać mapy InPost.'));
        document.head.appendChild(script);
      }).catch(error => {
        widgetLoadPromise = null;
        throw error;
      });
    }
    return widgetLoadPromise;
  };

  const syncCheckoutState = () => {
    const selectors = document.querySelectorAll('[data-inpost-selector]');
    if (!selectors.length) return;
    const selected = selectors[0].dataset.selectedPoint || '';
    selectors.forEach(selector => {
      const button = selector.querySelector('[data-inpost-open]');
      const hint = selector.querySelector('[data-inpost-hint]');
      const status = selector.querySelector('[data-inpost-status]');
      if (button) button.textContent = selected ? `Wybrany Paczkomat: ${selected}` : 'Wybierz Paczkomat';
      if (hint) hint.textContent = selected ? 'Możesz zmienić punkt przed przejściem do płatności.' : 'Przed przejściem do płatności wybierz Paczkomat.';
      if (status) status.textContent = selected ? 'Wybrano' : 'Wymagane';
    });
    document.querySelectorAll('button[name="checkout"], #checkout, .cart__checkout-button').forEach(button => {
      if (!(button instanceof HTMLButtonElement)) return;
      button.disabled = !selected;
      button.setAttribute('aria-disabled', String(!selected));
    });
    document.querySelectorAll('.additional-checkout-buttons, shopify-accelerated-checkout-cart').forEach(element => {
      element.hidden = !selected;
    });
  };

  const closeModal = selector => {
    const modal = selector?.querySelector('[data-inpost-modal]');
    if (modal instanceof HTMLDialogElement && modal.open) modal.close();
  };

  const savePoint = async payload => {
    const point = payload?.name || payload?.detail?.name || payload?.details?.name;
    if (!point) {
      console.error('InPost: wybór punktu nie zawiera kodu Paczkomatu.', payload);
      return;
    }
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { inpost_point_number: point } })
      });
      if (!response.ok) throw new Error('Nie udało się zapisać Paczkomatu.');
      const cart = await response.json();
      if (cart.attributes?.inpost_point_number !== point) throw new Error('Shopify nie potwierdził zapisu Paczkomatu.');
      document.querySelectorAll('[data-inpost-selector]').forEach(selector => {
        selector.dataset.selectedPoint = point;
        closeModal(selector);
      });
      syncCheckoutState();
    } catch (error) {
      console.error('InPost: błąd zapisu Paczkomatu:', error);
      document.querySelectorAll('[data-inpost-hint]').forEach(hint => {
        hint.textContent = 'Nie udało się zapisać punktu. Spróbuj ponownie.';
      });
    }
  };

  window.onpointselect = point => {
    void savePoint(point);
  };

  const openModal = selector => {
    const modal = selector.querySelector('[data-inpost-modal]');
    if (!(modal instanceof HTMLDialogElement)) return;
    try {
      if (!modal.open) modal.showModal();
    } catch (error) {
      console.error('InPost: nie można otworzyć okna wyboru:', error);
      return;
    }
    ensureWidget().then(() => {
      if (!modal.isConnected || !modal.open) return;
      const widget = modal.querySelector('inpost-geowidget');
      if (!widget) return;
      widget.setAttribute('onpoint', 'onpointselect');
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
        setTimeout(() => window.dispatchEvent(new Event('resize')), 120);
      });
    }).catch(error => {
      console.error('InPost: mapa nie została wczytana:', error);
      closeModal(selector);
      const hint = selector.querySelector('[data-inpost-hint]');
      if (hint) hint.textContent = 'Nie udało się wczytać mapy. Odśwież stronę i spróbuj ponownie.';
    });
  };

  document.addEventListener('click', event => {
    const openButton = event.target.closest?.('[data-inpost-open]');
    if (openButton) {
      const selector = openButton.closest('[data-inpost-selector]');
      if (selector) openModal(selector);
      return;
    }
    const closeButton = event.target.closest?.('[data-inpost-close]');
    if (closeButton) closeModal(closeButton.closest('[data-inpost-selector]'));
  });

  document.addEventListener('onpointselect', event => {
    void savePoint(event);
  });

  document.addEventListener('cart:update', syncCheckoutState);
  document.addEventListener('shopify:section:load', syncCheckoutState);
  syncCheckoutState();
})();
